import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Текстовая часть: одиночка по имени; группа — «N печатают…». */
function describe(users, kind) {
    const verb = kind === 'recording_voice' ? 'записывает голосовое' : 'печатает';
    const verbPlural = kind === 'recording_voice' ? 'записывают голосовое' : 'печатают';
    if (users.length === 0)
        return '';
    if (users.length === 1)
        return `${users[0]?.name} ${verb}…`;
    if (users.length === 2)
        return `${users[0]?.name} и ${users[1]?.name} ${verbPlural}…`;
    return `${users.length} участников ${verbPlural}…`;
}
export function TypingIndicator({ users, kind }) {
    if (users.length === 0)
        return null;
    const wrap = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        color: 'var(--color-accent)',
        fontSize: 'var(--font-sm)',
    };
    const dot = {
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        background: 'currentColor',
        animation: 'tc-ds-typing 1.2s var(--ease-standard) infinite',
    };
    return (_jsxs("span", { "data-typing": "", "data-kind": kind, style: wrap, children: [_jsxs("span", { "aria-hidden": "true", style: { display: 'inline-flex', gap: '3px' }, children: [_jsx("span", { style: { ...dot, animationDelay: '0ms' } }), _jsx("span", { style: { ...dot, animationDelay: '200ms' } }), _jsx("span", { style: { ...dot, animationDelay: '400ms' } })] }), _jsx("span", { "data-typing-text": "", children: describe(users, kind) })] }));
}
//# sourceMappingURL=TypingIndicator.js.map